/**
 * 正式项目管理api
 */
export default {
  /**
 * 分类列表api
 */
  projectList: '/projectCategory/list', // 分类列表
  newAdd: '/projectCategory/newAdd', //新增分类(新)
  newDelete: '/projectCategory/newDelete', //{categoryId}删除分类(新)
  newUpdate: '/projectCategory/newUpdate', //修改分类(新)
  /**
   * 项目审核api
   */
  selectProjectInfoList: '/projectInfo/selectProjectInfoList',//列表
  auditProjectInfo:'/projectInfo/auditProjectInfo',//审核
  selectProjectInfo:'/projectInfo/selectProjectInfo',//查看详情
   /**
   * 项目列表api
   */
   addProjectInfo:'/projectInfo/addProjectInfo',// 新增项目
   deletedProjectInfo:'/projectInfo/deletedProjectInfo',// 删除
   updateProjectInfo:'/projectInfo/updateProjectInfo',// 修改项目
   saleStatusProjectInfo:'/projectInfo/updateSaleStatus',// 批量上下架/上下架
   selectProjectAccountList:'/projectInfo/selectProjectAccountList',//分账列表
   /**
   * 项目套餐列表api
   */
   
   

   selectProjectPackageList:'/projectPackage/selectProjectPackageList',//列表
   updateProjectPackage:'/projectPackage/updateProjectPackage',//修改
   selectProjectPackageDetail:'/projectPackage/selectProjectPackageDetail',//详情
   insertProjectPackage:'/projectPackage/insertProjectPackage',//新增
   deleteProjectPackage:'/projectPackage/deleteProjectPackage',//删除
   auditProjectPackage:'/projectPackage/auditProjectPackage',//审核
   packageStatus:'/projectPackage/updateSaleStatus',//启动上下架
   
   


   

};
